module.exports = __webpack_public_path__ + "img/DW365-239.35eaba0e.jpg";